import React from 'react';
import Link from 'gatsby-link';
import Markdown from 'react-markdown';
import Helmet from 'react-helmet';
import styled from '../utils/styled';
import { Typography, Grid } from '@material-ui/core';
import Section from '../components/Section';

const content = `### Isikuandmete töötlemine
Elektroonnilise broneerimissüsteemi www.seikluseksperdid.ee isikuandmete vastutav töötleja on Seikluseksperdid OÜ (registrikood 14503058) asukohaga Tihasheina tee 9, 74117 Maardu, tel +372 52 75 333 ja e-kiri seiklus@seikluseksperdid.ee.

### Milliseid isikuandmeid töödeldakse
* isiku nimi kellele vahetult teenust osutatakse,
* isiku vanus kellele vahetult teenust osutatakse,
* teenuse tellija-kontaktisiku nimi,
* teenuse tellija-kontaktisiku e-posti aadress,
* teenuse tellija-kontaktisiku telefoninumber,
* juriidilisest isikust teenuse tellija registrikood,
* juriidilisest isikust teenuse tellija aadress

### Mis eesmärgil isikuandmeid töödeldakse
Isikuandmeid kasutatakse kliendi tellimuste haldamiseks ja teenuse osutamiseks. Broneeringuajaloo andmeid (broneeringu kuupäev, teenuse parameetrid, kliendi andmed) kasutatakse ostetud teenuste ülevaate koostamiseks ja kliendieelistuste analüüsimiseks, teenuse vahetuks osutamiseks. Isikuandmeid nagu nimed, e-post, telefoni nr, töödeldakse selleks, et osutada kvaliteetset teenust, lahendada teenuste osutamisega seonduvaid küsimusi (klienditugi) ja pidada raamatupidamisregistrit. Veebipoe kasutaja IP-aadressi või teisi võrguidentifikaatoreid töödeldakse veebipoe kui infoühiskonna teenuse osutamiseks ning veebikasutusstatistika tegemiseks.

### Õiguslik alus
Isikuandmete töötlemine toimub kliendiga sõlmitud lepingu täitmise eesmärgil. Isikuandmete töötlemine toimub juriidilise kohustuse täitmiseks (nt raamatupidamine ja tarbijavaidluste lahendamine).

### Vastuvõtjad, kellele isikuandmed edastatakse

Isikuandmed edastatakse vastutava töötleja volitatud töötajale teenuste ostuajaloo haldamiseks, teenuse osutamiseks ja kliendiprobleemide lahendamiseks.

Broneerimisüsteemi raamatupidamisregistri pidamine toimub teenusepakkuja juures ning teenuse osutamise ja kliendi andmed edastatakse raamatupidamisregistrisse raamatupidamistoimingute tegemiseks ja -ajaloo säilitamiseks.

Isikuandmeid edastatakse infotehnoloogia teenuste pakkujatele, kuna see on vajalik broneerimissüsteemi funktsionaalsuse ja andmemajutuse tagamiseks.

Isikuandmeid ei müüda ega jagata kolmandate osapooltega turunduse eesmärgil.

### Turvalisus ja andmetele ligipääs
Isikuandmeid hoitakse Google Ireland Limited serverites, mis asuvad Euroopa Liidu liikmesriigi või Euroopa Liidu majanduspiirkonnaga liitunud riikide territooriumil. Andmeid võidakse edastada riikidesse, mille andmekaitse taset on Euroopa Komisjon hinnanud piisavaks ning USA ettevõtetele, kes on liitund andmekaitse kilbi (Privacy Shield) raamistikuga.

Juurdepääs isikuandmetele on broneerimissüsteemi volitatud töötajatel, kes saavad isikuandmetega tutvuda selleks, et lahendada broneerimisüsteemi kasutamisega seonduvaid tehnilisi küsimusi ja osutada kliendile sisulist teenust.

Broneeringusüsteem rakendab asjakohaseid füüsilisi, organisatsioonilisi ja infotehnilisi turvameetmeid, et kaitsta isikuandmeid juhusliku või ebaseadusliku hävitamise, kaotsimineku, muutmise või loata juurdepääsu ja avalikustamise eest.

Isikuandmete edastamine broneerimisüsteemi volitatud töötlejatele (nt sündmuse organiseerija, instruktor) toimub broneeringusüsteemi ja volitatud töötlejatega sõlmitud lepingute alusel. Volitatud töötlejaid on kohustatud tagama isikuandmete töötlemisel asjakohased kaitsemeetmed.

### Isikuandmetega tutvumine ja parandamine
Isikuandmetega saab tutvuda broneerimissüsteemi klienditoe vahendusel. Broneerimisüsteemil puudub kasutajaprofiil.

### Nõusoleku tagasivõtmine
Kui isikundmete töötlemine toimub kliendi nõusoleku alusel, siis on kliendil õigus nõusolek tagasi võtta teavitades sellest kliendituge e-posti teel.

### Säilitamine
Kliendi nõudel või andmete kasutamise vajaduse ära langemisel kustutatakse isikuandmed, va juhul kui selliseid andmeid on vaja säilitada raamatupidamisregistri pidamise jaoks või tarbijavaidluste lahendamiseks.

Broneerimisüsteemis säilitatakse ostuajalugu kolm aastat.

Maksetega ja tarbijavaidlustega seotud vaidluste korral säilitatakse isikuandmed, kuni nõude täitmiseni või aegumistähtaja lõpuni.

Raamatupidamise jaoks vajalikud isikuandmed säilitatakse seitse aastat.

### Kustutamine
Isikuandmete kustutamiseks tuleb võtta ühendust klienditoega e-posti teel. Kustutamistaotlusele vastatakse mitte hiljem kui kuu aja jooksul ning täpsustakse andmete kustutamise perioodi ja asjaolud.

### Ülekandmine
E-posti teel esitatud isikuandmete ülekandmise taotlusele vastatakse hiljemalt kuu aja jooksul. Klienditugi tuvastab isikusamasuse ja teavitab isikuandmetest, mis kuuluvad ülekandmisele.

### Otseturustusteated
Andmete vastutav töötleja ei kasuta broneerimissüsteemi kaudu kogutud andmeid otseturunduse eesmärgil (profileerimine) ega otseturundusteadete edastamiseks.

### Vaidluste lahendamine
Isikuandmete töötlemisega seotud vaidluste lahendamine toimub klienditoe vahendusel (seiklus@seikluseksperdid.ee). Järelevalveasutus on Eesti Andmekaitse Inspektsioon (info@aki.ee).
`;

const PrivacyPolicy = ({ data }) => {
  return (
    <Section>
      <Grid item xs={12} sm={8}>
        <Helmet title="Privaatsuspoliitika" />
        <Typography variant="display1">Privaatsuspoliitika</Typography>
        <Typography align="justify" component={Markdown} source={content} escapeHtml={false} />
      </Grid>
    </Section>
  );
};
export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.js